const Purchase = {

    // PAGE HEADER
    "purchase": "Purchase",
    "search": "Search",

    // TABLE HEADER
    "table_plan_name": "PLAN NAME",
    "table_purchase_date": "PURCHASE DATE",
    "table_amount": "AMOUNT",
    "table_service": "SERVICE",
    "table_partner_name": "PARTNER NAME",
    "table_invoice": "INVOICE",

}

export default Purchase;
